<template>
  <div class="toggle" :class="{ enabled }" @click="toggle">
    <div class="toggle-label">
      <slot> label </slot>
    </div>
    <i v-if="enabled" class="fas fa-check"></i>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'test'
    },
    value: {
      type: [Boolean, Array],
      default: false
    }
  },
  data() {
    return {
      enabled:
        typeof this.value === 'boolean'
          ? this.value
          : this.value.includes(this.id)
    }
  },
  methods: {
    toggle() {
      this.enabled = !this.enabled
      if (typeof this.value === 'boolean') {
        this.$emit('input', this.enabled)
      } else {
        this.$emit(
          'input',
          this.enabled
            ? [...this.value, this.id]
            : this.value.filter(item => item !== this.id)
        )
      }
    }
  }
}
</script>

<style lang="scss">
.toggle {
  display: flex;
  position: relative;
  padding: 12px 5px 10px 5px;
  justify-content: space-between;
  align-items: baseline;
  cursor: pointer;
  background-color: white;
  color: #707070;
  i {
    color: #dddddd;
    padding-right: 10px;
  }
  &.enabled {
    background-color: #fafafa;
    color: #4b4b4b;
  }
}
</style>
